<template>
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4">
        <div class="tw-w-1/3 tw-hidden md:tw-flex">
            <v-img :src="getImagePath(this.contents.steps_to_join.image_desktop)" class="tw-w-16"></v-img>
        </div>
        <div class="tw-w-full lg:tw-w-2/3">
            <v-img :src="getImagePath(this.contents.steps_to_join.image_mobile)" v-if="!$vuetify.breakpoint.mdAndUp"></v-img>
            <div v-html="contents.steps_to_join.body" class="admin-generated"></div>
            <v-row no-gutters>
                <v-col>
                    <v-sheet class="pa-2 ma-2">
                        <a :href="documents.step_to_join_pdf_1 || '#'"><img :src="documents.step_to_join_image_pdf_1" alt="pdf_1" /></a>
                    </v-sheet>
                    <div class="text-lg font-light pb-3 text-left">
                        (1) MEMBERSHIP APPLICATION GUIDELINES
                    </div>
                </v-col>
                <v-col>
                    <v-sheet class="pa-2 ma-2">
                        <a :href="documents.step_to_join_pdf_2 || '#'"><img :src="documents.step_to_join_image_pdf_2" alt="pdf_2" /></a>
                    </v-sheet>
                    <div class="text-lg font-light pb-3 text-left">
                        (2) TRAINING PROGRAM FOR CAMERA TRAINEES
                    </div>
                </v-col>
                <v-col>
                    <v-sheet class="pa-2 ma-2">
                        <a :href="documents.step_to_join_pdf_3 || '#'"><img :src="documents.step_to_join_image_pdf_3" alt="pdf_3" /></a>
                    </v-sheet>
                    <div class="text-lg font-light pb-3 text-left">
                        (3) SAMPLE CAMERA TRAINEE APPLICANT RESUME
                    </div>
                </v-col>
            </v-row>

        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        name: "HowToJoinIndex",
        props: {
            'contents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'documents': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            }
        },
        methods:{
            getImagePath(image) {
                return `/storage/contents/${image}`;
            }
        },
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
    }
</script>
<style scoped>

.admin-generated >>> hr {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    font-family: ABCFavorit !important;
    }

</style>
